module.exports = __webpack_public_path__ + "static/media/bgImage.a5d6b615.jpg";